import { fetcher } from '@commenda/utils';

export async function deleteStakeholding(id: number) {
  const response = await fetcher(`capTable/stakeholding/${id}`, {
    method: 'DELETE',
  });

  return response;
}
